module.exports = __webpack_public_path__ + "static/choppedHero-39ee358a9d5ae4a58f4eb1e879700da6.png";